"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyTrialEndedCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const commands_1 = require("../../_shared/commands");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
const __1 = require("../..");
const TITLE = "Your trial of Polly has ended";
const MESSAGE = "Please upgrade to a paid subscription to continue using premium features";
const SurveyTrialEndedCard = (webDomain, disabledSchedules, messageAddress) => {
    const card = CardHelper_1.CardHelper.newCard();
    const container = (0, __1.SubscribeBlock)("msteams", TITLE, MESSAGE, webDomain, "trial-ended-dm");
    if ((disabledSchedules === null || disabledSchedules === void 0 ? void 0 : disabledSchedules.length) > 0) {
        const disabledNames = disabledSchedules.reduce((accum, schedule) => {
            accum += `* ${schedule.name}\n`;
            return accum;
        }, "");
        const message = `The following series have been disabled:\n\n${disabledNames}`;
        container.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
            color: adaptivecards_1.TextColor.Accent,
            horizontalAlignment: adaptivecards_1.HorizontalAlignment.Left,
            size: adaptivecards_1.TextSize.Medium,
            text: message,
            wrap: true,
        }));
    }
    card.addItem(container);
    card.addAction((0, commands_1.DeleteCardAction)(messageAddress));
    return card;
};
exports.SurveyTrialEndedCard = SurveyTrialEndedCard;
//# sourceMappingURL=SurveyTrialEndedCard.js.map